import template from './alert-legacy.html';

export default angular
  .module('app.alerts')
  .directive('holdingAlertLegacy', holdingAlertLegacy)
  .name;

function holdingAlertLegacy() {
  'ngInject';

  return {
    link,
    replace: true,
    restrict: 'E',
    scope: {
      onClose: '&?',
      title: '@?',
    },
    template,
    transclude: true,
  };

  function link(scope, _element, attrs, _ctrls, transclude) {
    scope.canClose = ('onClose' in attrs);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/alerts/directives/alert-legacy/alert-legacy.js